"use client";

import { ArrowRight, Asterisk } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const team = [{
  name: "M",
  role: "CHAUFFEUR",
  bio: "With fifteen years of precision driving, Marcus treats every route as a masterclass in timing and discretion.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/chauffeur_marcus_thorne.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/chauffeur_marcus_thorne.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/chauffeur_marcus_thorne.webp-wvc-sizes",
  nameClassName: "relative aspect-square overflow-hidden rounded-md !bg-[url(https://ypk.awf.mybluehost.me/wp-content/uploads/2026/07/IMG_3012.jpg)]"
}, {
  name: "Elena Vance",
  role: "LOGISTICS DIRECTOR",
  bio: "The architect of your itinerary. Danny ensures every connection is seamless, silent, and perfectly timed.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/logistics_elena_vance.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/logistics_elena_vance.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/logistics_elena_vance.webp-wvc-sizes"
}, {
  name: "Julian Reed",
  role: "FLEET SPECIALIST",
  bio: "Obsessive about the details. Badral maintains our fleet to a standard that exceeds factory specifications.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/fleet_julian_reed.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/fleet_julian_reed.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/fleet_julian_reed.webp-wvc-sizes"
}];
export default function ArchitectsOfArrival() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <Link className="bg-background text-foreground relative overflow-hidden py-28 md:py-40 underline cursor-pointer" to="https://book.mylimobiz.com/v4/bemax" newTab><section data-section-id="1848" id="architectsofarrival">
      {}
      <svg aria-hidden="true" viewBox="0 0 720 720" className="pointer-events-none absolute -top-20 -right-20 h-[360px] w-[360px] opacity-[0.05] md:h-[720px] md:w-[720px]" fill="none">
        <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" className="text-foreground">
          <path d="M360 60 C 380 220, 420 360, 560 480" />
          <path d="M360 60 C 320 200, 260 320, 120 440" />
          <path d="M360 60 L 360 540" />
          {Array.from({
            length: 14
          }).map((_, i) => {
            const t = (i + 1) / 15;
            const y = 60 + t * 480;
            const spread = 40 + t * 220;
            return <g key={i} data-index={i}>
                <path d={`M360 ${y} Q ${360 - spread / 2} ${y + 20}, ${360 - spread} ${y + 60}`} />
                <path d={`M360 ${y} Q ${360 + spread / 2} ${y + 20}, ${360 + spread} ${y + 60}`} />
              </g>;
          })}
        </g>
      </svg>

      <div className="relative mx-auto max-w-[1360px] px-6 md:px-10 lg:px-16">
        {}
        

        {}
        <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-7">
          {team.map((member, i) => <Card key={member.name} data-index={i} className="group flex flex-col gap-5 rounded-lg border border-border bg-card p-5 text-card-foreground shadow-md transition-all duration-[280ms] ease-out hover:-translate-y-1 hover:border-foreground">
              

              <div className="flex flex-col gap-3 px-1 pb-1">
                <Badge className="self-start rounded-sm bg-secondary px-2.5 py-1 font-mono text-[0.6875rem] font-medium uppercase tracking-[0.12em] text-secondary-foreground">
                  {member.role}
                </Badge>
                
                <p className="font-default text-sm leading-[1.55] text-muted-foreground">
                  {member.bio}
                </p>
              </div>
            </Card>)}

          {}
          <Card data-index={3} className="group relative flex flex-col justify-between overflow-hidden rounded-lg border border-border bg-card p-7 text-card-foreground shadow-md transition-all duration-[280ms] ease-out hover:-translate-y-1 hover:border-foreground">
            {}
            <div aria-hidden="true" className="pointer-events-none absolute -bottom-32 left-1/2 h-64 w-64 -translate-x-1/2 rounded-lg bg-foreground/5" />

            <div className="relative z-10 flex items-center gap-2 font-mono text-[0.6875rem] uppercase tracking-[0.18em] text-muted-foreground">
              <Asterisk className="size-3 text-foreground" strokeWidth={2.5} />
              <span>RESERVATIONS</span>
            </div>

            <div className="relative z-10 mt-6 flex flex-col gap-5">
              <h3 className="font-default text-[clamp(1.5rem,2vw,1.875rem)] font-semibold leading-[1.1] tracking-tight text-foreground">
                Secure your chauffeur
              </h3>
              <p className="font-default text-sm leading-[1.55] text-muted-foreground">
                Experience the BEMAX standard. Our team is ready to coordinate your next arrival.
              </p>

              <Link to="/SecureChauffeurPage" className="self-start">
                <Button variant="link" className="h-auto gap-1.5 px-0 font-default text-base font-medium text-foreground no-underline hover:no-underline">
                  <Link to="https://book.mylimobiz.com/v4/bemax" newTab data-ores-widget="quickres" data-ores-alias="bemax" className="relative underline cursor-pointer"><span>
                    Reserve Now
                    <svg aria-hidden="true" viewBox="0 0 80 10" preserveAspectRatio="none" className="absolute -bottom-1.5 left-0 h-2 w-full transition-all duration-[220ms] ease-out group-hover:w-[110%]" fill="none">
                      <path d="M2 6 Q 20 1, 40 5 T 78 5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                    </svg>
                  </span></Link>
                  <ArrowRight className="size-4 transition-transform duration-[220ms] group-hover:translate-x-1" />
                </Button>
              </Link>
            </div>
          </Card>
        </div>
      </div>
    </section></Link>;
}